export const getMap =  (state) => state.maps[state.mapid]
export const getMapById=  (state, id) => state.maps[id]


// WEBPACK FOOTER //
// ./src/vuex/getters.js